import React, { useState, useEffect, useRef } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import {
  InputLabel,
  TextField,
  Drawer,
  Button,
  FormControlLabel,
  CircularProgress,
  FormGroup,
  Checkbox,
  Autocomplete,
  Box,
  FormControl,
  Select,
  MenuItem,
  Chip,
  Stack,
  Paper,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import PreviewAndCompose from "./previewAndCompose";
import { useQuery, useMutation, useLazyQuery } from "@apollo/client";
import {
  LIST_EVENTS,
  LIST_ALL_MAIL_GROUPS,
  LIST_ENOTICELIST,
  GET_ALL_TOPICS,
} from "../../Graphql/queries";
import { CREATE_ENOTICE, UPDATE_ENOTICE } from "../../Graphql/mutations";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { toggleSnackbar } from "../../RactiveVariables/index";
import * as yup from "yup";
import SendMail from "./sendMail";
import { debounce, set } from "lodash";
import { useMemo } from "react";
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
export default function Overview(props) {
  const location = useLocation();
  const history = useHistory();
  const clone = location?.state?.detail;
  const { id } = useParams();
  const [defaultValue, setDefaultValue] = useState(null);

  const eventlist = props?.eventlist?.data;
  const [selectEvent, setSelectEvent] = useState("");
  const [newArray, setNewArray] = useState(null);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [isLoadingMoreTopics, setIsLoadingMoreTopics] = useState(false);
  const listboxRef = useRef(null);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [searchMailGroup, setSearchMailGroup] = useState("");
  const [searchTopics, setSearchTopics] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [topicinputValue, setTopicinputValue] = useState("");
  const [eventinputValue, setEventinputValue] = useState("");
  const topicslistboxRef = useRef(null);
  const [topicsscrollPosition, setTopicsScrollPosition] = useState(0);
  const getMailGroupVariables = {
    skip: 0,
    limit: 25,
    search: searchMailGroup,
    category: "",
    startDate: "",
  };

  const { data, loading, fetchMore, refetch } = useQuery(LIST_ALL_MAIL_GROUPS, {
    variables: getMailGroupVariables,
    fetchPolicy: "network-only",
    onCompleted: (res) => {
      // var arr = [];
      // // defaultValue?.createENotice?.toGpList ||
      // //   props?.enoticedetais?.eNoticeDetails?.toGpList?.forEach((element1) => {
      // //     let position = res?.listAllMailGroups?.data.findIndex(
      // //       (element) => element._id === element1
      // //     );
      // //     if (position > -1) {
      // //       arr.push(res?.listAllMailGroups?.data[position]);
      // //     }
      // //   });
      if (props?.enoticedetais?.eNoticeDetails) {
        setValue(
          "mailList",
          props?.enoticedetais?.eNoticeDetails?.toGpListDtls
        );
      }
    },
  });

  const handleFetchMore = async () => {
    if (isLoadingMore) return;

    setIsLoadingMore(true);
    // Store current scroll position
    if (listboxRef.current) {
      setScrollPosition(listboxRef.current.scrollTop);
    }

    try {
      // await fetchMore({
      //   variables: {
      //     skip: data?.listAllMailGroups?.data.length,
      //     limit: 25,
      //     search: searchMailGroup,
      //   },
      //   updateQuery: (prev, { fetchMoreResult }) => {
      //     if (!fetchMoreResult) return prev;
      //     return {
      //       listAllMailGroups: {
      //         ...fetchMoreResult.listAllMailGroups,
      //         data: [
      //           ...prev.listAllMailGroups.data,
      //           ...fetchMoreResult.listAllMailGroups.data,
      //         ],
      //       },
      //     };
      //   },
      // });
      await fetchMore({
        variables: {
          skip: data?.listAllMailGroups?.data.length,
          limit: 25,
          search: searchMailGroup,
        },
        updateQuery: (prev, { fetchMoreResult }) => {
          if (!fetchMoreResult) return prev;

          // Create a map of existing IDs for quick lookup
          const existingIds = new Set(
            prev.listAllMailGroups?.data?.map((item) => item._id)
          );

          // Filter out duplicates from new data
          const uniqueNewData = fetchMoreResult.listAllMailGroups.data.filter(
            (item) => !existingIds?.has(item._id)
          );

          return {
            listAllMailGroups: {
              ...fetchMoreResult.listAllMailGroups,
              data: [...prev.listAllMailGroups.data, ...uniqueNewData],
            },
          };
        },
      });
    } finally {
      setIsLoadingMore(false);
    }
  };

  useEffect(() => {
    if (listboxRef.current && scrollPosition > 0) {
      listboxRef.current.scrollTop = scrollPosition;
      setScrollPosition(0); // Reset stored position
    }
  }, [data?.listAllMailGroups?.data.length]);

  const debouncedSearch = debounce((value) => {
    setSearchMailGroup(value || "");
    // Reset to first page when search changes
    refetch({
      skip: 0,
      limit: 25,
      search: value,
      category: "",
      startDate: "",
    });
  }, 300);

  const getUserVariables = {
    skip: 0,
    limit: 25,
    isArchived: false,
    search: searchTopics,
  };

  const {
    data: topicList,
    fetchMore: FetchmoreTopics,
    refetch: refetchTopics,
    loading: topicsLoading,
  } = useQuery(GET_ALL_TOPICS, {
    fetchPolicy: "network-only",
    variables: getUserVariables,
    onCompleted: (res) => {
      if (props?.enoticedetais?.eNoticeDetails) {
        setValue(
          "topicList",
          props?.enoticedetais?.eNoticeDetails?.massTopicsDtls
        );
      }
      // var arr = [];
      // defaultValue?.createENotice?.massTopicsIds ||
      //   props?.enoticedetais?.eNoticeDetails?.massTopicsIds?.forEach(
      //     (element1) => {
      //       let position = res?.listTopics?.data?.findIndex(
      //         (element) => element._id === element1
      //       );
      //       if (position > -1) {
      //         arr.push(res?.listTopics?.data?.[position]);
      //       }
      //     }
      //   );
      // setValue("topicList", arr);
    },
  });

  const handleFetchMoreTopics = async () => {
    if (isLoadingMoreTopics) return;

    setIsLoadingMoreTopics(true);
    // Store current scroll position
    if (topicslistboxRef.current) {
      setTopicsScrollPosition(topicslistboxRef.current.scrollTop);
    }

    // try {
    //   await FetchmoreTopics({
    //     variables: {
    //       skip: topicList?.listTopics?.data.length,
    //       limit: 25,
    //       search: searchTopics,
    //       isArchived: false,
    //     },
    //     updateQuery: (prev, { fetchMoreResult }) => {
    //       if (!fetchMoreResult) return prev;
    //       return {
    //         listTopics: {
    //           ...fetchMoreResult.listTopics,
    //           data: [
    //             ...prev.listTopics.data,
    //             ...fetchMoreResult.listTopics.data,
    //           ],
    //         },
    //       };
    //     },
    //   });
    // }
    try {
      await FetchmoreTopics({
        variables: {
          skip: topicList?.listTopics?.data.length,
          limit: 25,
          search: searchTopics,
          isArchived: false,
        },
        updateQuery: (prev, { fetchMoreResult }) => {
          if (!fetchMoreResult) return prev;

          const mergedData = [
            ...prev.listTopics.data,
            ...fetchMoreResult.listTopics.data,
          ].reduce((acc, current) => {
            const exists = acc.some((item) => item._id === current._id);
            return exists ? acc : [...acc, current];
          }, []);

          return {
            listTopics: {
              ...fetchMoreResult.listTopics,
              data: mergedData,
            },
          };
        },
      });
    } catch (error) {
      console.error("Error fetching more topics:", error);
    } finally {
      setIsLoadingMoreTopics(false);
    }
  };
  useEffect(() => {
    if (topicslistboxRef.current && topicsscrollPosition > 0) {
      topicslistboxRef.current.scrollTop = topicsscrollPosition;
      setScrollPosition(0); // Reset stored position
    }
  }, [topicList?.listTopics?.data.length]);

  const debouncedTopicsSearch = debounce((value) => {
    setSearchTopics(value || "");
    // Reset to first page when search changes
    refetchTopics({
      skip: 0,
      limit: 25,
      search: searchTopics,
      isArchived: false,
    });
  }, 300);

  const [createEnotice] = useMutation(CREATE_ENOTICE, {
    refetchQueries: ["listAllENotice"],
    onCompleted: (res) => {
      props.setOverviewRes(res);
      props.setCreateRes(res);

      setDefaultValue(res);
      // setSelectEvent(res)
      props.setTabValue("Preview & Compose");
      props.setCreate(true);
    },
  });

  const [updateENotice] = useMutation(UPDATE_ENOTICE, {
    refetchQueries: ["listAllENotice"],
    onCompleted: (res) => {
      props.setOverviewRes(res);
      setDefaultValue(res);

      // setSelectEvent(res)
      props.setTabValue("Preview & Compose");
    },
  });

  const schema = yup.object().shape({
    allEventList:
      props?.checkedList === "Event"
        ? yup.object().required("Event List is Required").nullable()
        : null,
    // .of(
    //   yup.object().shape({
    //     value: yup.string(),
    //     label: yup.string()
    //   })
    // )
    // .min(1, "Event List is Required").,

    // .of(
    //   yup.object().shape({
    //     value: yup.string(),
    //     label: yup.string()
    //   })
    // )
    // mailList: yup.array()
    // .min(1, "Either Mailing Group or Topic is required").required(" Mail List is Required"),
    // topicList: yup.array()
    // .min(1, "Either Mailing Group or Topic is Required").required("Topic is Required"),
    mailList: yup.array().test({
      test: function (mailList) {
        const topicList = this.parent.topicList;

        if (
          (!mailList || mailList.length === 0) &&
          (!topicList || topicList.length === 0)
        ) {
          // If neither mailList nor topicList is selected, show an error
          throw this.createError({
            message: "Either Mail List or Topic Notification is required",
            path: "mailList",
          });
        }

        return true;
      },
    }),
    topicList: yup.array(),
    // allEventList:yup.string().required("Subject is Required"),
    // mailList:yup.string().required("Subject is Required"),
    subject: yup.string().required("Subject is Required"),
    from: yup.string().required("From is Required"),
    // fromLabel : yup.string().required("From Label is Required"),
    replyTo: yup.string().required("Reply To is Required"),
    // bcc: yup.string().required("Bcc is Required"),
  });
  const { register, handleSubmit, formState, reset, control, setValue } =
    useForm({
      resolver: yupResolver(schema),
    });
  const { errors } = formState;
  const getIdValue = (array) => {
    if (array) {
      let id = [];
      array.forEach((element) => {
        id.push(element._id);
      });
      return id;
    }
  };

  const getTopicId = (array) => {
    if (array) {
      let id = [];
      array.forEach((element) => {
        id.push(element._id);
      });
      return id;
    }
  };
  const onSubmit = (params) => {
    let data = {
      toGpList: getIdValue(params.mailList),
      massTopicsIds: getTopicId(params.topicList),
      ccList: [params.bcc],
      fromLabel: params.fromLabel,
      from: params.from,
      replyTo: params.replyTo,
      eventId: params.allEventList?._id || "",
      eNoticeType: props.checkedList,
      subject: params.subject,
      content: props?.enoticedetais?.eNoticeDetails?.content ?? "",
      status: "Draft",
    };

    if (props.create === false && (id === "$" || clone === "clone")) {
      try {
        createEnotice({ variables: { data: data } })
          .then((res) => {
            toggleSnackbar({
              status: true,
              message:
                clone === "clone"
                  ? "E-Notice cloned successfully"
                  : "E-Notice updated successfully",
              variant: "success",
            });
          })
          .catch((error) => {
            const message = error && error.message;
            toggleSnackbar({
              status: true,
              message: message,
              variant: "error",
            });
          });
      } catch (error) {
        const message = error && error.message;
        toggleSnackbar({
          status: true,
          message: message,
          variant: "error",
        });
      }
    } else {
      try {
        updateENotice({
          variables: {
            _id: props?.enoticedetais?.eNoticeDetails._id ?? id,
            data: data,
          },
        })
          .then((res) => {
            toggleSnackbar({
              status: true,
              message: "E-Notice updated successfully",
              variant: "success",
            });
          })
          .catch((error) => {
            const message = error && error.message;
            toggleSnackbar({
              status: true,
              message: message,
              variant: "error",
            });
          });
      } catch (error) {
        const message = error && error.message;
        toggleSnackbar({
          status: true,
          message: message,
          variant: "error",
        });
      }
    }
  };

  // const regesterEventList = register("eventList");
  // const regesterMailingList = register("mailingList");

  return (
    <div className="container">
      <div className="row">
        <div className="col-sm-12">
          <div className="card border-0">
            <form
              noValidate
              className="card-body"
              onSubmit={handleSubmit(onSubmit)}
            >
              <div className="border-btm">
                <FormControlLabel
                  disabled={
                    props?.enoticedetais?.eNoticeDetails?.eNoticeType ===
                    "Other"
                  }
                  control={
                    <Checkbox
                      checked={props.checkedList === "Event" ? true : false}
                      // onChange={handleChangeIndividual}
                      onChange={() => props.setCheckedList("Event")}
                      icon={<RadioButtonUncheckedIcon />}
                      checkedIcon={<CheckCircleIcon />}
                    />
                  }
                  label="Event "
                />
                <FormControlLabel
                  disabled={
                    props?.enoticedetais?.eNoticeDetails?.eNoticeType ===
                    "Event"
                  }
                  control={
                    <Checkbox
                      checked={props.checkedList === "Other" ? true : false}
                      // onChange={handleChangeUpload}
                      onChange={() => props.setCheckedList("Other")}
                      icon={<RadioButtonUncheckedIcon />}
                      checkedIcon={<CheckCircleIcon />}
                    />
                  }
                  label="Other"
                />
              </div>
              {
                <div className="col-sm-12">
                  {(props.checkedList === "Event" ||
                    props?.enoticedetais?.eNoticeDetails?.eNoticeType ===
                      "Event") && (
                    <Box className="mb-3" sx={{ minWidth: 120 }}>
                      {/* <FormControl fullWidth> */}
                      <InputLabel className="form-label">
                        Event List<sup className="text-danger">*</sup>
                      </InputLabel>
                      <Controller
                        name="allEventList"
                        control={control}
                        defaultValue={
                          props?.enoticedetais?.eNoticeDetails?.eventDtls
                        }
                        render={({ field: { onChange, value } }) => (
                          <Autocomplete
                            className="autocomplete-field"
                            disablePortal
                            variant="outlined"
                            // options={eventlist || []}
                            options={[
                              ...(eventlist || []),
                              ...(props.isLoadingMoreEvents
                                ? [{ _id: "loading", isPlaceholder: true }]
                                : []),
                            ]}
                            // value={value || null}
                            defaultValue={
                              props?.enoticedetais?.eNoticeDetails?.eventDtls
                            }
                            loading={
                              props.eventsloading || props.isLoadingMoreEvents
                            }
                            loadingText={
                              <span style={{ color: "#4165ac" }}>
                                Loading...
                              </span>
                            }
                            getOptionLabel={(option) =>
                              option.isPlaceholder
                                ? "Loading more..."
                                : option.title
                            }
                            onChange={(event, val) => onChange(val)}
                            // onChange={(event, value) => {
                            //   // Filter out the loading placeholder if selected
                            //   onChange(
                            //     value?.filter((opt) => !opt.isPlaceholder)
                            //   );
                            // }}
                            inputValue={eventinputValue}
                            onInputChange={(event, newInputValue) => {
                              setEventinputValue(newInputValue); // Update input text
                              props.debouncedEventSearch(newInputValue); // Trigger search
                            }}
                            renderOption={(props, option) =>
                              option.isPlaceholder ? (
                                <li
                                  {...props}
                                  style={{
                                    display: "flex",
                                    justifyContent: "start",
                                    alignItems: "center",
                                    gap: "5px",
                                    pointerEvents: "none", // Disable click
                                    opacity: 0.8,
                                  }}
                                >
                                  <span
                                    style={{
                                      marginLeft: "5px",
                                      color: "#4165ac",
                                    }}
                                  >
                                    Loading...
                                  </span>
                                  <CircularProgress size={15} />
                                </li>
                              ) : (
                                <li {...props}>{option.title}</li>
                              )
                            }
                            ListboxProps={{
                              ref: props.eventlistboxRef,
                              onScroll: ({ currentTarget }) => {
                                if (props.isLoadingMoreEvents) return;
                                const scrollPosition =
                                  currentTarget.scrollTop +
                                  currentTarget.clientHeight;
                                if (
                                  currentTarget.scrollHeight - scrollPosition <=
                                  1
                                ) {
                                  if (
                                    props.eventlist?.data.length <
                                    props.eventlist?.count
                                  ) {
                                    props.handleFetchMoreEvents();
                                  }
                                }
                              },
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <>{params.InputProps.endAdornment}</>
                                  ),
                                }}
                              />
                            )}
                          />
                        )}
                      />
                      {/* </FormControl> */}
                      {errors && errors?.["allEventList"] && (
                        <p className="errorMessage text-danger">
                          {errors?.allEventList?.message}
                        </p>
                      )}
                    </Box>
                  )}
                  <div className="col-md-12 mb-3">
                    <InputLabel className="form-label">
                      Subject<sup className="text-danger">*</sup>
                    </InputLabel>
                    <TextField
                      className="w-100"
                      variant="outlined"
                      defaultValue={
                        props?.enoticedetais?.eNoticeDetails?.subject
                      }
                      {...register("subject")}
                      error={errors.subject}
                    />
                    {errors && errors?.["subject"] && (
                      <p className="errorMessage text-danger">
                        {errors?.subject?.message}
                      </p>
                    )}
                  </div>
                  <div className="col-md-12 mb-3 topics-tags">
                    <InputLabel className="form-label">
                      Topic Notifications
                    </InputLabel>
                    <Controller
                      name="topicList"
                      control={control}
                      // defaultValue={newArray}
                      defaultValue={
                        props?.enoticedetais?.eNoticeDetails?.massTopicsDtls
                      }
                      render={({ field: { onChange, value } }) => (
                        <Autocomplete
                          className="loc-autocomplete"
                          multiple
                          variant="outlined"
                          // id="tags-outlined"
                          loading={topicsLoading || isLoadingMoreTopics}
                          loadingText={
                            <span style={{ color: "#4165ac" }}>Loading...</span>
                          }
                          defaultValue={
                            props?.enoticedetais?.eNoticeDetails?.massTopicsDtls
                          }
                          options={[
                            ...(topicList?.listTopics?.data.filter(
                              (option) =>
                                !value?.some(
                                  (selected) => selected._id === option._id
                                )
                            ) || []),
                            ...(isLoadingMoreTopics
                              ? [{ _id: "loading", isPlaceholder: true }]
                              : []),
                          ]}
                          // getOptionLabel={(option) => option.topic}
                          getOptionLabel={(option) =>
                            option.isPlaceholder
                              ? "Loading more..."
                              : option.topic
                          }
                          // onChange={(event, value) => {
                          //   onChange(value);
                          // }}
                          onChange={(event, value) => {
                            // Filter out the loading placeholder if selected
                            onChange(value.filter((opt) => !opt.isPlaceholder));
                          }}
                          inputValue={topicinputValue}
                          onInputChange={(event, newInputValue) => {
                            setTopicinputValue(newInputValue); // Update input text
                            debouncedTopicsSearch(newInputValue); // Trigger search
                          }}
                          filterSelectedOptions
                          renderOption={(props, option) =>
                            option.isPlaceholder ? (
                              <li
                                {...props}
                                style={{
                                  display: "flex",
                                  justifyContent: "start",
                                  alignItems: "center",
                                  gap: "5px",
                                  pointerEvents: "none", // Disable click
                                  opacity: 0.8,
                                }}
                              >
                                <span
                                  style={{
                                    marginLeft: "5px",
                                    color: "#4165ac",
                                  }}
                                >
                                  Loading...
                                </span>
                                <CircularProgress size={15} />
                              </li>
                            ) : (
                              <li {...props}>{option.topic}</li>
                            )
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>{params.InputProps.endAdornment}</>
                                ),
                              }}
                            />
                          )}
                          ListboxProps={{
                            ref: topicslistboxRef,
                            onScroll: ({ currentTarget }) => {
                              if (isLoadingMoreTopics) return;
                              const scrollPosition =
                                currentTarget.scrollTop +
                                currentTarget.clientHeight;
                              if (
                                currentTarget.scrollHeight - scrollPosition <=
                                1
                              ) {
                                if (
                                  topicList?.listTopics?.data.length <
                                  topicList?.listTopics?.count
                                ) {
                                  handleFetchMoreTopics();
                                }
                              }
                            },
                          }}
                        />
                      )}
                    />
                    {errors && errors?.["topicList"] && (
                      <p className="errorMessage text-danger">
                        {errors?.topicList?.message}
                      </p>
                    )}
                  </div>

                  <div className="col-md-12 mb-3">
                    <InputLabel className="form-label">
                      Select Mailing Groups
                    </InputLabel>
                    <Controller
                      name="mailList"
                      control={control}
                      // defaultValue={newArray}
                      defaultValue={
                        props?.enoticedetais?.eNoticeDetails?.toGpListDtls
                      }
                      render={({ field: { onChange, value } }) => (
                        <Autocomplete
                          autoHighlight
                          className="loc-autocomplete"
                          multiple
                          variant="outlined"
                          // id="tags-outlined"
                          sx={{
                            "& .MuiAutocomplete-option:hover": {
                              backgroundColor: "#000 !important", // Hover effect
                            },
                          }}
                          defaultValue={
                            props?.enoticedetais?.eNoticeDetails?.toGpListDtls
                          }
                          // value={value || []}
                          loading={loading}
                          loadingText={
                            <span style={{ color: "#4165ac" }}>Loading...</span>
                          }
                          options={[
                            ...(data?.listAllMailGroups?.data.filter(
                              (option) =>
                                !value?.some(
                                  (selected) => selected._id === option._id
                                )
                            ) || []),
                            ...(isLoadingMore
                              ? [{ _id: "loading", isPlaceholder: true }]
                              : []),
                          ]}
                          // getOptionLabel={(option) => option.groupName}
                          getOptionLabel={(option) =>
                            option.isPlaceholder
                              ? "Loading more..."
                              : option.groupName
                          }
                          // onChange={(event, value) => {
                          //   onChange(value);
                          // }}
                          onChange={(event, value) => {
                            // Filter out the loading placeholder if selected
                            onChange(value.filter((opt) => !opt.isPlaceholder));
                          }}
                          inputValue={inputValue}
                          onInputChange={(event, newInputValue) => {
                            setInputValue(newInputValue); // Update input text
                            debouncedSearch(newInputValue); // Trigger search
                          }}
                          // defaultValue={[top100Films[13]]}
                          filterSelectedOptions
                          renderOption={(props, option) =>
                            option.isPlaceholder ? (
                              <li
                                {...props}
                                style={{
                                  display: "flex",
                                  justifyContent: "start",
                                  alignItems: "center",
                                  gap: "5px",
                                  pointerEvents: "none", // Disable click
                                  opacity: 0.8,
                                }}
                              >
                                <span
                                  style={{
                                    marginLeft: "5px",
                                    color: "#4165ac",
                                  }}
                                >
                                  Loading...
                                </span>
                                <CircularProgress size={15} />
                              </li>
                            ) : (
                              <li {...props}>{option.groupName}</li>
                            )
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>{params.InputProps.endAdornment}</>
                                ),
                              }}
                            />
                          )}
                          ListboxProps={{
                            ref: listboxRef,
                            onScroll: ({ currentTarget }) => {
                              if (isLoadingMore) return;
                              const scrollPosition =
                                currentTarget.scrollTop +
                                currentTarget.clientHeight;

                              if (
                                currentTarget.scrollHeight - scrollPosition <=
                                1
                              ) {
                                if (
                                  data?.listAllMailGroups?.data.length <
                                  data?.listAllMailGroups?.count
                                ) {
                                  handleFetchMore();
                                }
                              }
                            },
                          }}
                          // PaperComponent={({ children, ...props }) => (
                          //   <Paper
                          //     {...props}
                          //     style={{
                          //       ...props.style,
                          //       backgroundColor: "#fff", // Solid white background
                          //       boxShadow:
                          //         "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)",
                          //     }}
                          //   >
                          //     {children}
                          //     {isLoadingMore && (
                          //       <div
                          //         style={{
                          //           padding: "10px",
                          //           textAlign: "start",
                          //           color: "#666",
                          //           fontSize: "0.875rem",
                          //           backgroundColor: "#fff", // Match the background
                          //           borderTop: "1px solid #eee", // Optional separator
                          //         }}
                          //       >
                          //         <CircularProgress
                          //           size={20}
                          //           style={{ marginRight: "8px" }}
                          //         />
                          //         Loading more...
                          //       </div>
                          //     )}
                          //   </Paper>
                          // )}
                        />
                      )}
                    />
                    {errors && errors?.["mailList"] && (
                      <p className="errorMessage text-danger">
                        {errors?.mailList?.message}
                      </p>
                    )}
                  </div>
                  <div className="col-md-12 mb-3">
                    <div className="row ">
                      <Box className="col-md-6 mb-3" sx={{ minWidth: 120 }}>
                        <InputLabel className="form-label">
                          From<sup className="text-danger">*</sup>
                        </InputLabel>
                        <TextField
                          className="w-100"
                          variant="outlined"
                          defaultValue={
                            props?.enoticedetais?.eNoticeDetails?.from || null
                          }
                          {...register("from")}
                          error={errors.from}
                        />
                        {errors && errors?.["from"] && (
                          <p className="errorMessage text-danger">
                            {errors?.from?.message}
                          </p>
                        )}
                        {/* <FormControl fullWidth>
                        <InputLabel className="form-label">From</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          variant="outlined"
                          className="w-100"
                          id="demo-simple-select"
                          value={chooseFile}
                          onChange={handleChooseFile}
                          label="Choose File"
                        >
                          <MenuItem value={"Choose File"}>
                            {"Choose File"}
                          </MenuItem>
                          <MenuItem value={10}>Member 1</MenuItem>
                          <MenuItem value={20}>Member 2</MenuItem>
                          <MenuItem value={30}>Member 3</MenuItem>
                        </Select>
                      </FormControl> */}
                      </Box>
                      <Box className="col-md-6 mb-3" sx={{ minWidth: 120 }}>
                        <InputLabel className="form-label">
                          From Label
                        </InputLabel>
                        <TextField
                          className="w-100"
                          variant="outlined"
                          defaultValue={
                            props?.enoticedetais?.eNoticeDetails?.fromLabel ||
                            null
                          }
                          {...register("fromLabel")}
                          error={errors.fromLabel}
                        />
                        {errors && errors?.["fromLabel"] && (
                          <p className="errorMessage text-danger">
                            {errors?.fromLabel?.message}
                          </p>
                        )}
                        {/* <FormControl fullWidth>
                        <InputLabel className="form-label">From Label</InputLabel>
                        <Select
                        variant="outlined"
                        className="w-100"
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={chooseFile}
                          onChange={handleChooseFile}
                          label="Choose File"
                        >
                          <MenuItem value={"Choose File"}>
                            {"Choose File"}
                          </MenuItem>
                          <MenuItem value={10}>Member 1</MenuItem>
                          <MenuItem value={20}>Member 2</MenuItem>
                          <MenuItem value={30}>Member 3</MenuItem>
                        </Select>
                      </FormControl> */}
                      </Box>
                      <Box className="col-md-6" sx={{ minWidth: 120 }}>
                        <InputLabel className="form-label">
                          Reply To<sup className="text-danger">*</sup>
                        </InputLabel>
                        <TextField
                          className="w-100"
                          variant="outlined"
                          defaultValue={
                            props?.enoticedetais?.eNoticeDetails?.replyTo ||
                            null
                          }
                          {...register("replyTo")}
                          error={errors.replyTo}
                        />
                        {errors && errors?.["replyTo"] && (
                          <p className="errorMessage text-danger">
                            {errors?.replyTo?.message}
                          </p>
                        )}
                        {/* <FormControl fullWidth>
                        <InputLabel className="form-label">Replay To</InputLabel>
                        <Select
                          variant="outlined"
                          className="w-100"
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={chooseFile}
                          onChange={handleChooseFile}
                          label="Choose File"
                        >
                          <MenuItem value={"Choose File"}>
                            {"Choose File"}
                          </MenuItem>
                          <MenuItem value={10}>Member 1</MenuItem>
                          <MenuItem value={20}>Member 2</MenuItem>
                          <MenuItem value={30}>Member 3</MenuItem>
                        </Select>
                      </FormControl> */}
                      </Box>
                      <Box className="col-md-6" sx={{ minWidth: 120 }}>
                        <InputLabel className="form-label">BCC</InputLabel>
                        <TextField
                          className="w-100"
                          variant="outlined"
                          defaultValue={
                            props?.enoticedetais?.eNoticeDetails?.ccList[0] ||
                            null
                          }
                          {...register("bcc")}
                          error={errors.bcc}
                        />
                        {errors && errors?.["bcc"] && (
                          <p className="errorMessage text-danger">
                            {errors?.bcc?.message}
                          </p>
                        )}
                        {/* <FormControl fullWidth>
                        <InputLabel className="form-label">BCC</InputLabel>
                        <Select
                          variant="outlined"
                          className="w-100"
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={chooseFile}
                          onChange={handleChooseFile}
                          label="Choose File"
                        >
                          <MenuItem value={"Choose File"}>
                            {"Choose File"}
                          </MenuItem>
                          <MenuItem value={10}>Member 1</MenuItem>
                          <MenuItem value={20}>Member 2</MenuItem>
                          <MenuItem value={30}>Member 3</MenuItem>
                        </Select>
                      </FormControl> */}
                      </Box>
                    </div>
                  </div>
                  {/* <Box className="col-md-12" sx={{ minWidth: 120 }}>
                  <FormControl fullWidth>
                    <InputLabel className="form-label">Templete</InputLabel>
                    <Select
                      variant="outlined"
                      className="w-100"
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={chooseFile}
                      onChange={handleChooseFile}
                      label="Choose File"
                    >
                      <MenuItem value={"Choose File"}>{"Choose File"}</MenuItem>
                      <MenuItem value={10}>Member 1</MenuItem>
                      <MenuItem value={20}>Member 2</MenuItem>
                      <MenuItem value={30}>Member 3</MenuItem>
                    </Select>
                  </FormControl>
                </Box> */}
                </div>
              }
              <div className="d-flex justify-content-between mt-3 align-items-center btn-section">
                <Button
                  className="btn outline-btn"
                  onClick={() => history.goBack()}
                >
                  Cancel
                </Button>
                <div className="d-flex align-items-center">
                  <Button type="submit" className="btn btn-orange">
                    Next
                    {/* {clone==="clone"?"Clone List":id==="$"? "Create List":"Update List"} */}
                  </Button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
